
import { Button } from "@/components/ui/button";

interface EmptyListingStateProps {
  searchQuery: string;
  onClearSearch: () => void;
}

const EmptyListingState = ({ searchQuery, onClearSearch }: EmptyListingStateProps) => {
  return (
    <div className="text-center p-8 border rounded-lg bg-gray-50">
      <h3 className="text-lg font-medium">No listings found</h3>
      <p className="text-muted-foreground mt-2">
        {searchQuery ? 
          "No listings match your search. Try different keywords." : 
          "You haven't created any listings yet. Add your first property!"}
      </p>
      {searchQuery && (
        <Button variant="outline" className="mt-4" onClick={onClearSearch}>
          Clear search
        </Button>
      )}
    </div>
  );
};

export default EmptyListingState;
